import request from '@/utils/request'

export { getUploadTempSignature } from '../background/api'

export function getTombstoneTemplateList() {
  return request.get('/asset/tombstone_template/list')
}

export function saveTombstoneTemplate(imageUrl) {
  return request.post('/asset/tombstone_template/save', { image_url: imageUrl })
}

export function deleteTombstoneTemplate(templateId) {
  return request.post('/asset/tombstone_template/delete', { template_id: templateId })
}

export function sortTombstoneTemplate(templateId, sort) {
  const n = Number(sort)
  return request.post('/asset/tombstone_template/sort', {
    template_id: templateId,
    sort: n,
    sort_order: n
  })
}
